const state = {
  userIds: []
}
const mutations = {
  ADD_USER: (state, id) => {
    if (state.userIds.includes(id)) return
    state.userIds.push(id)
  },
  REMOVE_USER: (state, id) => {
    if (state.userIds.includes(id)) {
      state.userIds = state.userIds.filter(item => item !== id)
    }
  },
  CLEAR_USERS: (state) => {
    state.userIds = []
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
